<div
  *ngIf="!is_list_running"
  class="sp-width__full sp-min-height__full sp-column">
  <div class="sp-row__align sp-wrap sp-margin__bottom">
    <app-shared-pill
      content="{{ this.total }} {{ 'GENERAL.RESULTS_LABEL' | translate }}"
      [content_class]="'sp-color__accent-contrast'"
      [pill_class]="'sp-background__accent'"></app-shared-pill>
  </div>

  <app-product-category-data-table
    *ngIf="product_categories?.length"
    [product_categories]="product_categories || []"
    (refresh)="refresh.emit()"
    (scrolledToEnd)="onScrollEnd()"
    class="sp-width__full"></app-product-category-data-table>
</div>

<app-loading *ngIf="is_list_running"></app-loading>
